import React from "react";

import AppColors from "../../constants/AppColors";

import Button from "../base/Button";
import Glyphicon from "../base/Glyphicon";

class RedirectTableRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false,
    };

    this._onMouseEnter = this._onMouseEnter.bind(this);
    this._onMouseLeave = this._onMouseLeave.bind(this);
    this._onDelete = this._onDelete.bind(this);
  }

  _onMouseEnter() {
    this.setState({ hovered: true });
  }

  _onMouseLeave() {
    this.setState({ hovered: false });
  }

  _onDelete() {
    if (this.props.onDelete) {
      this.props.onDelete(this.props.redirect);
      this.setState({ hovered: false });
    }
  }

  _controls() {
    return (
      <div style={{ width: "4%", textAlign: "right" }}>
        <Button
          look="link"
          style={{ margin: 0, padding: 0, lineHeight: 1 }}
          onClick={this._onDelete}
        >
          <Glyphicon glyph="bin" />
        </Button>
      </div>
    );
  }

  render() {
    let redirect = this.props.redirect;
    let rowStyle = {
      padding: 12,
      display: "flex",
      cursor: "pointer",
      alignItems: "center",
    };

    let controls = this.state.hovered ? this._controls() : null;

    return (
      <div style={rowStyle} onMouseEnter={this._onMouseEnter} onMouseLeave={this._onMouseLeave}>
        <div style={{ width: "40%", wordWrap: "break-word", paddingRight: 8 }}>
          {redirect.get("from_url")}
        </div>
        <div style={{ width: "56%", wordWrap: "break-word" }}>{redirect.get("to_url")}</div>
        {controls}
      </div>
    );
  }
}

export default RedirectTableRow;
